import { cn } from "@getgreenline/blaze-ui";
import { countryLabels, getBrandInitials } from "@/utils/brands";
import { CardBadge } from "../../shared/card-badge";
import { SelectableCard } from "../../shared/selectable-card";

type BrandCardProps = {
  name?: string;
  description?: string | null;
  avatarImageUrl?: string | null;
  country?: string | null;
  selected?: boolean;
  onClick?: () => void;
};

export function BrandCard({
  name,
  description,
  avatarImageUrl,
  country,
  selected = false,
  onClick,
}: BrandCardProps) {
  return (
    <SelectableCard
      interactive={onClick != undefined}
      selected={selected}
      onSelect={onClick}
      contentClassName="tw:flex tw:items-center tw:gap-3"
    >
      {avatarImageUrl ? (
        <img
          src={avatarImageUrl}
          alt={name ?? "Brand"}
          className="tw:h-12 tw:w-12 tw:shrink-0 tw:rounded-xl tw:object-cover"
        />
      ) : (
        <div
          className={cn(
            "tw:flex tw:h-12 tw:w-12 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-xl tw:bg-sky-100 tw:text-xs tw:font-semibold tw:text-sky-700",
          )}
        >
          {getBrandInitials(name)}
        </div>
      )}

      <div className="tw:min-w-0 tw:flex-1">
        <div className="tw:flex tw:flex-col tw:gap-1">
          <h2 className="tw:text-sm tw:font-semibold tw:leading-none tw:text-foreground">
            {name}
          </h2>
          {country && (
            <p className="tw:line-clamp-2 tw:text-sm tw:text-muted-foreground">
              {countryLabels[country]}
            </p>
          )}
          {description && (
            <p className="tw:line-clamp-2 tw:text-sm tw:text-muted-foreground">
              {description}
            </p>
          )}
        </div>
        <div className="tw:mt-2">
          <CardBadge className="tw:bg-muted tw:text-muted-foreground">
            Catalog brand
          </CardBadge>
        </div>
      </div>
    </SelectableCard>
  );
}
